import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Icon } from 'antd';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  theme: PropTypes.string.isRequired,
  objectType: PropTypes.string.isRequired,
  objectId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  selectedAccountId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  patchAttachAccount: PropTypes.func.isRequired
};

class AttachAction extends React.PureComponent {
  handleCancel = () => {
    const { objectType, objectId, history } = this.props;
    history.push(`/${objectType}/${objectId}`);
  }

  handleAttach = () => {
    const {
      objectType,
      objectId,
      selectedAccountId,
      patchAttachAccount
    } = this.props;
    patchAttachAccount(objectType, objectId, selectedAccountId, this.handleCancel);
  }

  render() {
    const {
      theme,
      selectedAccountId
    } = this.props;

    return (
      <div>
        {selectedAccountId &&
          <Button className={`${theme}-theme-btn mr-md`} onClick={this.handleAttach}>
            <Icon type="swap" />
            <FormattedMessage id="page.AttachAccount.attachAccount" />
          </Button>
        }
        <Button onClick={this.handleCancel}>
          <Icon type="close" />
          <FormattedMessage id="page.AttachAccount.cancel" />
        </Button>
      </div>
    );
  }
}

AttachAction.propTypes = propTypes;

export default withRouter(AttachAction);



// WEBPACK FOOTER //
// ./src/views/AttachAccount/components/AttachAction.jsx